import React from "react"
import { withRouter } from "react-router-dom"
import { Dropdown, Menu, Container } from "semantic-ui-react"

const NavBar = (props) => {
  const { history, user, logout, login, isAuthenticated } = props
  return (
    <div className="noprint">
      <Menu inverted>
        <Container>
          <Menu.Item as="a" header onClick={() => history.push("/")}>
            Μεταθέσεις Στρατιωτικού Προσωπικού
          </Menu.Item>

          <Menu.Menu position="right">
            {isAuthenticated ? (
              <Dropdown item simple direction="right" text={user.profile.sub}>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={logout}>Αποσύνδεση</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            ) : (
              <Menu.Item as="a" onClick={login}>
                Σύνδεση
              </Menu.Item>
            )}
          </Menu.Menu>
        </Container>
      </Menu>
    </div>
  )
}
export default withRouter(NavBar)
